/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_TitleInputs */

const vi_trace_title = /** @type {(inputs: Trace_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nguồn gốc lô chè`)
};

/**

* @param {Trace_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_title = /** @type {((inputs?: Trace_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_title(inputs)
});